import { useTranslation } from 'react-i18next';

import { Badge } from '@/components/ui/daisy/badge';
import { Colors, Sizes } from '@/components/ui/types';
import { ActivityBlockType } from '@/models/Activity';

type ActivityTypeBadgeProps = {
  type?: ActivityBlockType;
  size?: Sizes;
};

const colorMap: Record<ActivityBlockType, Colors> = {
  [ActivityBlockType.REGULAR]: 'primary',
  [ActivityBlockType.MANUAL_GRADE]: 'secondary',
  [ActivityBlockType.OPTIONAL]: 'error',
  [ActivityBlockType.CONSOLIDATION]: 'warning',
};

export default function ActivityTypeBadge({
  type,
  size,
}: ActivityTypeBadgeProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'activityBlockTypes',
  });

  if (!type) return null;

  return (
    <Badge size={size} color={colorMap[type]}>
      {t(type)}
    </Badge>
  );
}
